module.exports = __webpack_public_path__ + "img/17.b6e6d1ad.png";